import {DataStatus} from 'platform/components';
import {Center} from 'platform/foundation';

import {isNotEmpty, isNotNil} from 'ramda';

import {
  buildUrl,
  getWorkspaceFromUri,
  iamQueryParams,
  iamRedirectRoute,
  redirectToLogin,
} from '@dms/routes';

import {useBoolean, useOnMount, useQueryState} from 'shared/web';

export function ResetPasswordRedirect() {
  const [token] = useQueryState('token');
  const [email] = useQueryState('email');

  const {workspace} = getWorkspaceFromUri();

  const [isError, triggerError] = useBoolean(false);

  useOnMount(() => {
    if (!token) {
      triggerError();
      return;
    }

    const redirectUrl = `${buildUrl(iamRedirectRoute, workspace, false)}?${iamQueryParams.ORIGIN_URI}=${encodeURIComponent(window.location.origin)}`;

    redirectToLogin({
      page: 'reset-password',
      additionalQueryParams: {token},
      currentUserEmail: isNotNil(email) && isNotEmpty(email) ? email : undefined,
      redirectUrl,
    });
  });

  return (
    <Center height="100vh" width="100%">
      <DataStatus isLoading isError={isError} />
    </Center>
  );
}
